import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  loadLitePlayerJSFiles,
  setSlikeConfig,
  handleEvents,
  playerErrorCallback,
  playerloadError,
  attachEventsToJS,
} from './util';
import { processLitePlayerFnQueue, getApiKey } from './helper';

const Player = props => {
  const {
    divId,
    slikeId,
    isMobile,
    videoClassName,
    globalRefId,
    isEtimes,
    isFullPlayer,
    skipDiv,
  } = props;

  useEffect(() => {
    const pageProps = {
      isMobile,
      isEtimes,
      isFullPlayer,
    };
    const { Channel } = window?.Times?.adsKeys || {};
    if (Channel === 'etimes') {
      pageProps.isEtimes = true;
    }
    const apiKey = getApiKey(pageProps);
    pageProps.apiKey = apiKey;
    window.lwPlayer = window.lwPlayer || {};
    let player = window.lwPlayer[globalRefId];
    window.lwplayerConfig = window.lwplayerConfig || {};
    window.lwplayerConfig[globalRefId] =
      window.lwplayerConfig[globalRefId] || {};
    const afterPlayerLoaded = recheckCount => {
      const CleoPlayer = window?.CleoPlayer;
      if (CleoPlayer) {
        const slikeConfig = setSlikeConfig(props, pageProps);
        if (!slikeConfig) {
          return;
        }
        analyticsWrapper('ga4', {
          event: 'player_load',
          status: 'success',
          video_template: props.tmplSource,
        });
        processLitePlayerFnQueue(globalRefId);

        window.lwPlayer[globalRefId] = new CleoPlayer(slikeConfig, error => {
          if (error) {
            console.error(error);
            playerErrorCallback(error, props);
            return;
          }
          player = window.lwPlayer[globalRefId];
          handleEvents(player, CleoPlayer.Events, props);
        });
      } else if (recheckCount > 3) {
        playerloadError('CleoPlayer not found');
        console.error('CleoPlayer not found');
      } else {
        setTimeout(() => {
          afterPlayerLoaded(recheckCount + 1);
        }, 3000 * recheckCount);
      }
    };
    const lwMinitvObj = window?.lwObj && window.lwObj[globalRefId];

    if (player && lwMinitvObj) {
      attachEventsToJS(player, globalRefId, props);
      processLitePlayerFnQueue(globalRefId);
    } else {
      loadLitePlayerJSFiles(pageProps, () => {
        afterPlayerLoaded(1);
      });
    }
  }, []);

  if (!slikeId || !divId || skipDiv) {
    return null;
  }
  return (
    <div
      id={divId}
      className={videoClassName}
      dangerouslySetInnerHTML={{ __html: '' }}
      suppressHydrationWarning
    />
  );
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isPrime: state.isPrime,
});
Player.propTypes = {
  divId: PropTypes.string.isRequired,
  slikeId: PropTypes.string.isRequired,
  videoClassName: PropTypes.string,
  globalRefId: PropTypes.string,
  isMobile: PropTypes.bool,
  isEtimes: PropTypes.bool,
  isFullPlayer: PropTypes.bool,
  skipDiv: PropTypes.bool,
};
Player.defaultProps = {
  isMobile: false,
  videoClassName: '',
  globalRefId: 'common',
  isEtimes: false,
  isFullPlayer: false,
  skipDiv: false,
};
export default connect(mapStateToProps)(Player);
